import Flowplayer from "./flowplayer";
import { useFlowplayer } from "./hooks";
export default Flowplayer;
export { useFlowplayer };
